import ImagePlaceholder from "@/components/base/ImagePlaceholder";

export default function Hero() {
  return (
    <section className="relative mt-16 md:mt-20 w-full min-h-[420px] md:min-h-[600px] h-auto overflow-hidden">
      <div className="absolute inset-0">
        <ImagePlaceholder
          src="https://readdy.ai/api/search-image?query=Professional%20technician%20repairing%20a%20roller%20shutter%20on%20a%20residential%20house%20exterior%2C%20wearing%20work%20uniform%20with%20tools%2C%20warm%20daylight%2C%20clean%20modern%20French%20suburban%20setting%2C%20realistic%20service%20photography%20showing%20quality%20craftsmanship%2C%20professional%20repairman%20at%20work%2C%20editorial%20style%20with%20natural%20colors%20and%20soft%20lighting&width=1600&height=900&seq=hero-reparateur-2026&orientation=landscape"
          alt="Véhicule d'intervention volet roulant dans le Bas-Rhin"
          className="absolute inset-0 w-full h-full"
          loading="eager"
          fetchpriority="high"
        />
      </div>
      <div className="absolute inset-0 bg-[#143A66]/70"></div>
      <div className="relative z-10 flex flex-col items-center justify-center h-full px-4 text-center">
        <div className="max-w-[80%] mx-auto">
          <h1 className="text-2xl md:text-5xl font-bold text-white mb-3 md:mb-4 animate-hero-fade-up">
            Nos zones d'intervention dans le Bas-Rhin
          </h1>
          <p className="text-lg md:text-xl text-white/90 mb-5 md:mb-8 animate-hero-fade-up animate-delay-100">
            Nos techniciens se déplacent partout à Strasbourg et dans le Bas-Rhin.
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-2 md:gap-4 animate-hero-fade-up animate-delay-200 justify-center">
            <a
              href="tel:0374473240"
              className="bg-brand-cyan text-white px-5 py-3 md:px-8 md:py-3.5 rounded-full font-semibold text-base hover:bg-brand-cyan/90 transition-all duration-200 btn-hover-effect whitespace-nowrap"
            >
              Appeler le 03 74 47 32 40
            </a>
            <a
              href="#devis"
              className="border border-white text-white px-5 py-3 md:px-8 md:py-3.5 rounded-full font-semibold text-base hover:bg-white/10 transition-all duration-200 btn-hover-effect whitespace-nowrap"
            >
              Devis gratuit
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}